import React, { ReactElement } from "react"
import {
  ParcelOrderInfosBloc,
  ParcelOrderInfosContainer,
  ParcelOrderInfosData,
  ParcelOrderInfosLabel,
} from "components/Parcels/ParcelOrderInfos/ParcelOrderInfos.styled"
import moment from "moment"
import { OrderStatus } from "types/order.types"

interface ParcelOrderInfosProps {
  orderStatus: OrderStatus
  orderType: string
  deliveryCode?: number | null
  shipper: string | null
  maxHoldingDate?: Date
  description?: string | null
}

const ParcelMaxHoldingDate = ({ maxHoldingDate, orderStatus }: { maxHoldingDate?: Date; orderStatus: OrderStatus }) => {
  if (
    !maxHoldingDate ||
    [OrderStatus.DELIVERED_TO_RECIPIENT, OrderStatus.RETURN_COMPLETED, OrderStatus.CANCELLED].includes(orderStatus)
  )
    return

  const targetDate = moment.utc(maxHoldingDate).startOf("day")
  const today = moment.utc().startOf("day")
  const daysRemaining = targetDate.diff(today, "days")
  const formattedDate = targetDate.format("D MMMM")
  const result =
    daysRemaining >= 0
      ? `${daysRemaining}j restants (${formattedDate})`
      : `Dépassé de ${Math.abs(daysRemaining)}j (${formattedDate})`

  return (
    <ParcelOrderInfosBloc>
      <ParcelOrderInfosLabel>⌛ Delai d’instance</ParcelOrderInfosLabel>
      <ParcelOrderInfosData>{result}</ParcelOrderInfosData>
    </ParcelOrderInfosBloc>
  )
}

function ParcelOrderInfos({
  orderStatus,
  orderType,
  deliveryCode,
  shipper,
  maxHoldingDate,
  description,
}: ParcelOrderInfosProps): ReactElement {
  return (
    <ParcelOrderInfosContainer>
      <ParcelOrderInfosBloc>
        <ParcelOrderInfosLabel>📱 Code desti</ParcelOrderInfosLabel>
        <ParcelOrderInfosData>{deliveryCode ?? "-"}</ParcelOrderInfosData>
      </ParcelOrderInfosBloc>
      <ParcelOrderInfosBloc>
        <ParcelOrderInfosLabel>🏷 Type</ParcelOrderInfosLabel>
        <ParcelOrderInfosData>{orderType}</ParcelOrderInfosData>
      </ParcelOrderInfosBloc>
      <ParcelOrderInfosBloc>
        <ParcelOrderInfosLabel>👕 Marchand</ParcelOrderInfosLabel>
        <ParcelOrderInfosData>{shipper}</ParcelOrderInfosData>
      </ParcelOrderInfosBloc>
      <ParcelMaxHoldingDate maxHoldingDate={maxHoldingDate} orderStatus={orderStatus} />
      {description && (
        <ParcelOrderInfosBloc>
          <ParcelOrderInfosLabel>📝 Description</ParcelOrderInfosLabel>
          <ParcelOrderInfosData>{description}</ParcelOrderInfosData>
        </ParcelOrderInfosBloc>
      )}
    </ParcelOrderInfosContainer>
  )
}

export default ParcelOrderInfos
